(function () {
	const announcementSlider = () => {
		$(".announcement-bar__slide").each(function () {
			if ($(this).hasClass("slider_started")) {
				return "";
			}
			if ($(".announcement-bar")) {
				$(this).addClass("slider_started");
			}

			const announcementId = $(this).data("announcement-id");
			const delay = $(this).data("delay") * 1000;
			const autoplay = $(this).data("autoplay");
			if (autoplay) {
				autoplayParm = {
					autoplay: {
						delay: delay,
						pauseOnMouseEnter: true,
						disableOnInteraction: false
					},
				};
			} else {
				autoplayParm = {};
			}
			let swiperParms={
					loop: true,
					navigation: {
						nextEl: `#shopify-section-${announcementId} .announcement-btn-next`,
						prevEl: `#shopify-section-${announcementId} .announcement-btn-prev`,
					},
					...autoplayParm,
			};
			const announcementSwiper = new Swiper(
				`.announcement-js-${announcementId}`, swiperParms
			);
		});
	};

	announcementSlider();
	document.addEventListener("shopify:section:load", function () {
		announcementSlider();
	});
})();
